import moment from 'moment-timezone';
import { toast } from 'react-toastify';
const timeZone = 'Asia/Karachi';
const handleCharCount = (char, limit) => {
  return `${char < limit ? char : limit}/${limit}`;
};
const decideUserRole = (role) => {
  if (role === 'doctor') return 'Dr';

  return 'Mr';
};
const isTruthy = (value, replace = 0) => {
  return value ? value : replace;
};
const verifyForm = (formValues, values, errors, touched) => {
  let isDisabled = false;
  for (let value of formValues) {
    // if (values[value] != null && !Object.keys(errors).includes(value)) {
    //   isDisabled = false;
    // }
    if (Object.keys(errors).length === 0 && Object.keys(touched).length === 0) {
      isDisabled = true;
    }
    if (Object.keys(errors).includes(value)) {
      isDisabled = true;
    }
  }
  return isDisabled;
};
const numberFormatter = (number) => {
  return number?.toLocaleString();
};
const sum = (array = [], fieldName) => {
  const reduce = array?.reduce((accumulator, currentValue) => {
    return accumulator + currentValue[fieldName];
  }, 0);
  return reduce;
};
const formattedDate = (timestamp) => {
  moment.tz(timestamp).format('DD MMM YYYY, hh:mm A');
};
const formatPhoneNumber = (number) => {
  // return number?.replace(/(\d{3})(\d{7})/, '$1 $2');
  return number ? number?.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3') : '';
};
// const formattedNumber = number.replace(/(\d{4})(\d{3})(\d{4})/, '$1 $2 $3');
const slotsFormatter = (array) => {
  const categorizedSlots = {
    morning: [],
    evening: [],
    night: []
  };
  array.forEach((slot) => {
    const fromHour = new Date(slot.timeFrom).getHours();
    const timeFrom = new Date(slot.timeFrom).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
    const timeTo = new Date(slot.timeTo).toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit'
    });
    const formattedSlot = { timeFrom, timeTo };
    if (fromHour >= 6 && fromHour < 12) {
      categorizedSlots.morning.push(formattedSlot);
    } else if (fromHour >= 12 && fromHour < 18) {
      categorizedSlots.evening.push(formattedSlot);
    } else if (fromHour >= 18 && fromHour < 24) {
      categorizedSlots.night.push(formattedSlot);
    }
  });
  Object.keys(categorizedSlots).forEach((data) => {
    if (categorizedSlots[data].length === 0) {
      delete categorizedSlots[data];
    }
  });
  return categorizedSlots;
};
function getRelevantMrValue(input) {
  // Split the input by slashes
  const parts = input?.split('/');
  // Get the last part and remove leading zeroes
  let relevant;
  if (Array.isArray(parts)) relevant = parts[parts.length - 1].replace(/^0+/, '');
  return relevant;
}
const formattedDatePart = (dateTime) => moment.tz(dateTime, timeZone).format('DD MMMM YYYY'); // "21 June 2024"
const formattedTime = (dateTime) => moment.tz(dateTime, timeZone).format('h:mm A'); // "4:03 P
function decideDuration(value) {
  if (value === 0) {
    return 'Today';
  } else if (value >= 7 && value < 30) {
    const weeks = Math.floor(value / 7);
    return `${weeks} week${weeks > 1 ? 's' : ''}`; // Add "s" for plural weeks
  } else if (value >= 30) {
    const months = Math.floor(value / 30);
    return `${months} month${months > 1 ? 's' : ''}`; // Add "s" for plural months
  } else {
    const days = Math.floor(value); // Drop decimal part
    return `${days} day${days > 1 ? 's' : ''}`; // Add "s" for plural days
  }
}

const calculateRemainingDays = (subscriptionEndDate) => {
  const endDate = moment.tz(subscriptionEndDate, timeZone);
  // Get the current date in the same time zone
  const currentDate = moment.tz(timeZone);

  // Calculate the difference in days
  const remainingDays = endDate.diff(currentDate, 'days', true);
  return Math.max(0, Math.ceil(remainingDays));
};

// Check if the current date is within the range

const checkDatePassed = (startDate, endDate) => {
  const currentDate = moment.tz(timeZone);
  const isWithinRange = currentDate.isBetween(moment.tz(startDate), moment.tz(endDate), null, '[]');
  return isWithinRange;
};
const formatNames = (names) => {
  if (names.length > 3) {
    const displayedNames = names.slice(0, 3).join(', ');
    const remainingCount = names.length - 3;
    return `${displayedNames}, +${remainingCount}`;
  } else {
    return names.join(', ');
  }
};
const findLatestDateFromAnArray = (dates) => {
  if (!dates || dates.length === 0) {
    return ''; // Return null if the array is empty or undefined
  }

  const latestDate = dates.reduce((latest, current) => {
    return moment(current).isAfter(moment(latest)) ? current : latest;
  });

  // Format the latest date in "DD MMM YYYY" format
  if (latestDate) return moment(latestDate).format('DD MMM YYYY');
};

const convertIntoDate = (ageInput, selected) => {
  let todayDate = new Date();
  let DOB;

  if (selected === 'Yrs') {
    // Adjust the year
    DOB = new Date(todayDate.setFullYear(todayDate.getFullYear() - ageInput));
  } else if (selected === 'Mon') {
    // Adjust the month
    DOB = new Date(todayDate.setMonth(todayDate.getMonth() - ageInput));
  } else if (selected === 'Day') {
    // Adjust the day
    DOB = new Date(todayDate.setDate(todayDate.getDate() - ageInput));
  } else {
    return toast.error('Invalid selection for "selected" parameter.');
  }
  // createPatient.form.setFieldValue('dateOfBirth', moment(DOB)?.format('YYYY-MM-DD'));
  // console.log('when', ageInput, selected, moment(DOB)?.format('YYYY-MM-DD'));

  return moment(DOB)?.format('YYYY-MM-DD');
};
const transformServices = (services) => {
  const result = [];
  const serviceMap = {};
  if (services?.length)
    for (const service of services) {
      const { serviceId, serviceName, serviceFees } = service;

      if (serviceId === null || serviceId === undefined) {
        // Handle services with no serviceId separately
        result.push({ ...service, quantity: 1 });
        continue;
      }

      if (!serviceMap[serviceId]) {
        // Add a new service to the map
        serviceMap[serviceId] = { ...service, quantity: 1 };
      } else {
        // Increase the quantity for the existing service
        serviceMap[serviceId].quantity += 1;
      }
    }

  // Combine results from map and the remaining services
  return [...Object.values(serviceMap), ...result];
};

const convertInISOFormat = (date) => {
  // Set your desired time zone, e.g., 'America/New_York'
  // Use 'UTC' or your preferred time zone
  // Get the current date and time in the specified time zone
  // Use the provided date or default to the current date
  const momentDate = date ? moment.tz(date, timeZone) : moment.tz(timeZone);
  // Return the formatted ISO 8601 string
  return momentDate.toISOString();
};
const todayTimeRange = (timeZone = 'UTC') => {
  const startDateTime = moment().tz(timeZone).startOf('day').toISOString();
  const endDateTime = moment().tz(timeZone).endOf('day').toISOString();
  return {
    startDateTime,
    endDateTime
  };
};

const appointmentDateRange = () => {
  return {
    startDateTime: '1900-01-01T00:00:00.000Z',
    endDateTime: '4028-12-31T23:59:59.999Z'
  };
};

const formatAndValidateNumber = (value) => {
  // Remove non-numeric characters
  const numericValue = value.replace(/\D/g, '');

  // Ensure the number has at most 7 digits
  if (numericValue.length > 7) return { formatted: '', valid: false };

  // Add commas for formatting
  const formatted = numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return { formatted, valid: true };
};
const convertTemperature = (temp, toFahrenheit) => {
  if (!temp || isNaN(temp)) return '';
  const numTemp = parseFloat(temp);
  if (toFahrenheit) {
    // Celsius to Fahrenheit
    return ((numTemp * 9) / 5 + 32).toFixed(1);
  } else {
    // Fahrenheit to Celsius
    return (((numTemp - 32) * 5) / 9).toFixed(1);
  }
};

function calculateDiscountedPrice(originalPrice, discountPercentage) {
  // Ensure the discount percentage is between 0 and 100
  if (discountPercentage < 0 || discountPercentage > 100) {
    toast.error('Discount percentage should be between 0 and 100.');
  }
  // Calculate the discount amount
  const discountAmount = (discountPercentage / 100) * originalPrice;
  // Calculate the final price after applying the discount
  const finalPrice = originalPrice - discountAmount;

  return finalPrice;
}

const parseBooleanFromString = (str) => {
  if (typeof str === 'string') return str.toLowerCase() === 'true';
};

const appointmentSorting = (appointments = []) => {
  return [...appointments].sort((a, b) => {
    // Handle deleted status - isDeleted: false should go last
    if (a.isDeleted && !b.isDeleted) {
      return 1;
    }
    // If a isDeleted is false and b isDeleted is true, a should come before b
    if (!a.isDeleted && b.isDeleted) {
      return -1;
    }
    // If both have the same isDeleted value, maintain their current order
    return 0;
  });
};
const eventOrderCustom = (eventA, eventB) => {
  // Access isDeleted and appointmentStartDateTime from extendedProps
  const isDeletedA = eventA.isDeleted || false;
  const isDeletedB = eventB?.isDeleted || false;
  // First, sort by isDeleted status
  if (isDeletedA && !isDeletedB) {
    return 1; // eventA is deleted, it should come after eventB
  } else if (!isDeletedA && isDeletedB) {
    return -1; // eventB is deleted, it should come after eventA
  }
  // If both events have the same isDeleted status, sort by appointmentStartDateTime
  const startA = new Date(eventA?.appointmentStartDateTime);
  const startB = new Date(eventB?.appointmentStartDateTime);
  return startA - startB; // Sort in ascending order of start time
};

function daysPassed(inputDate) {
  const startDate = moment(inputDate, 'YYYY-MM-DD'); // Parse the input date
  const currentDate = moment(); // Get the current date
  const differenceInDays = currentDate.diff(startDate, 'days'); // Calculate the difference in days
  console.log(
    "differenceInDays > 0 ? `${differenceInDays} days` : 'To",
    differenceInDays > 0 ? `${differenceInDays} days` : 'To'
  );
  return differenceInDays > 0 ? `${differenceInDays} days` : 'Today';
}
const convertIntoISO = (params) => {
  return moment(params).format('YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
};

export {
  calculateDiscountedPrice,
  formattedDatePart,
  formattedTime,
  formattedDate,
  numberFormatter,
  verifyForm,
  isTruthy,
  decideUserRole,
  handleCharCount,
  sum,
  formatPhoneNumber,
  slotsFormatter,
  getRelevantMrValue,
  decideDuration,
  calculateRemainingDays,
  checkDatePassed,
  formatNames,
  findLatestDateFromAnArray,
  convertIntoDate,
  transformServices,
  convertInISOFormat,
  todayTimeRange,
  formatAndValidateNumber,
  convertTemperature,
  parseBooleanFromString,
  appointmentDateRange,
  appointmentSorting,
  eventOrderCustom,
  daysPassed,
  convertIntoISO
};
